'use client';

import { COMMON_UI_UTILS } from '@drift/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';

interface AvgFillPriceCellProps {
	order: ParentOrderInfo;
}

export function AvgFillPriceCell({ order }: AvgFillPriceCellProps) {
	const { baseAssetAmountFilled, quoteAssetAmountFilled } = order;

	if (baseAssetAmountFilled.eqZero()) {
		return <span className="text-text-tertiary">-</span>;
	}

	const avgPriceBn = COMMON_UI_UTILS.calculateAverageEntryPrice(
		quoteAssetAmountFilled,
		baseAssetAmountFilled
	);

	return avgPriceBn.toNotional(true);
}
